import { buildURL, buildFullPath, pickData } from './_utils';

/**
 * api 工厂创建函数
 * @param request
 * @returns
 * @description api 工厂的工厂
 */
export const createApiFoctory =
  (
    request
  ) =>
  (
    options
  ) =>
  (
    ...args
  ) => {
    const {
      data: outerData,
      params: outerParams,
      options: outerOptions,
    } = (args?.[0] || {});
    const { url, method, data = {}, params = {}, baseURL, ...restOptions } = options;
    const pickedData = pickData(outerData, data);
    const pickedParams = pickData(outerParams, params);
    // console.log('---outerParams, params--->', outerParams, params);

    const fullPath = buildFullPath(url, baseURL);
    // console.log('---fullPath, pickedParams, buildURL--->', fullPath, pickedParams, buildURL(fullPath, pickedParams));

    const requestParams = {
      ...restOptions,
      ...outerOptions,
      data: pickedData,
      method: method.toUpperCase(),
      url: buildURL(fullPath, pickedParams),
    };

    return request(requestParams);
  };

export default createApiFoctory;
